

export default function getProducts(room, austattung_produkt){

    const productList = [];
    // let frameCount = 0;
    let combinations = {
        name: room.name,
        combinations: [],
        products: {
            schaltbare: [],
            normal: []
        }
    };
    if(
        room.selectedEquipment["steckdosen-eneg"] !== undefined
        && room.selectedEquipment["steckdosen-eneg"] > 0
        && austattung_produkt["steckdosen-eneg"] !== undefined
    ){
        productList.push({
            product: austattung_produkt["steckdosen-eneg"],
            count: room.selectedEquipment["steckdosen-eneg"]
        })
        // frameCount += room.selectedEquipment["steckdosen-eneg"];
        for (let i = 0; i<room.selectedEquipment["steckdosen-eneg"];i++) {
            combinations.products.schaltbare.push(austattung_produkt["steckdosen-eneg"]);
        }
        console.log('added schaltbare', 'steckdosen-eneg', room.selectedEquipment['steckdosen-eneg'])
    }
    if(
        room.selectedEquipment["steckdosen-home"] !== undefined
        && room.selectedEquipment["steckdosen-home"] > 0
        && austattung_produkt["steckdosen-home"] !== undefined
    ){
        productList.push({
            product: austattung_produkt["steckdosen-home"],
            count: room.selectedEquipment["steckdosen-home"]
        })
        // frameCount += room.selectedEquipment["steckdosen-home"];
        for (let i = 0; i<room.selectedEquipment["steckdosen-home"];i++) {
            combinations.products.schaltbare.push(austattung_produkt["steckdosen-home"]);
        }
    }

    if(
        room.selectedEquipment["steckdosen"] !== undefined
        && room.selectedEquipment["steckdosen"] > 0
        && austattung_produkt["steckdosen"] !== undefined
    ){
        productList.push({
            product: austattung_produkt["steckdosen"],
            count: room.selectedEquipment["steckdosen"]
        })
        for (let i = 0; i<room.selectedEquipment["steckdosen"];i++) {
            combinations.products.normal.push(austattung_produkt["steckdosen"]);
        }
    }

    // const frames = [
    //     {key: "r-5f", counter: 5},
    //     {key: "r-4f", counter: 4},
    //     {key: "r-3f", counter: 3},
    //     {key: "r-2f", counter: 2},
    //     {key: "r-1f", counter: 1},
    // ];
    // frames.forEach(frame => {
    //     const c = Math.floor(frameCount / frame.counter);
    //     // console.log('parsing frame', frame, c, '=', frameCount,'/',frame.counter, frameCount/frame.counter)
    //     if (c > 0) {
    //         frameCount -= c * frame.counter;
    //         productList.push({
    //             product: austattung_produkt[frame.key],
    //             count: c
    //         });
    //         // console.log('remaining frameCount', frameCount)
    //         for(let i = 0; i < c; i++) {
    //             let position = 1;
    //             let comb = {
    //                 frame: austattung_produkt[frame.key],
    //                 factor: 1,
    //                 orientation: 'H',
    //                 controlElements: [],
    //                 origin: 'addSteckdosen, 79'
    //             };
    //             for (let j = 0; j < frame.counter; j++) {
    //                 comb.controlElements.push({
    //                     position: position,
    //                     insert: combinations.products.shift()
    //                 });
    //                 position += 1;
    //             }
    //             combinations.combinations.push(comb);
    //         }
    //     }
    // });
    // console.log('returning steckdosen productlist', productList, room.selectedEquipment);
    return { productList: productList, combinations: combinations.products, aust_list: ["steckdosen-eneg","steckdosen-home","steckdosen"] };
}
